import { render, staticRenderFns } from "./AddChargeAccount.vue?vue&type=template&id=2bf430d8&"
import script from "./AddChargeAccount.vue?vue&type=script&lang=js&"
export * from "./AddChargeAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports